import React from 'react'

import AddSuperadminForm from '../../modules/Superadmin/components/AddSuperadminForm'
export default function AddSuperadminPage() {
  return <AddSuperadminForm />
}
